/**
 * Pointer-capability checks.
 *
 * Touch devices report `(pointer: coarse)`; mouse/trackpad devices report
 * `(pointer: fine)`. Devices without a pointing device match neither, so both
 * helpers return false — callers should treat that as "don't auto-focus".
 */
const COARSE_QUERY = "(pointer: coarse)";
const FINE_QUERY = "(pointer: fine)";

function matches(query: string): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(query).matches;
}

/** True on touch-first devices (phones, tablets). */
export function isCoarsePointer(): boolean {
  return matches(COARSE_QUERY);
}

/** True on mouse/trackpad devices. */
export function hasFinePointer(): boolean {
  return matches(FINE_QUERY);
}
